/* Import self-hosted Prompt fonts CSS */
import './src/styles/fonts.css';

/**
 * Scroll to hash anchor on page load and route changes
 * This handles cases where the URL has query parameters along with hash fragments
 */
export const onRouteUpdate = ({ location }) => {
  // Extract hash from location.hash (works even with query params)
  const hash = location.hash;

  if (hash) {
    // Remove the # symbol and extract just the ID (in case query params are in the hash)
    // e.g., "#treatments?c=123" -> "treatments"
    const id = hash.substring(1).split('?')[0];

    // Wait for the page to render before scrolling
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        // Calculate offset for fixed header if needed
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  }
};

/**
 * Handle hash scrolling on initial page load
 */
export const onInitialClientRender = () => {
  // Check if there's a hash in the URL on initial load
  if (typeof window !== 'undefined' && window.location.hash) {
    // Extract just the ID (in case query params are in the hash)
    // e.g., "#treatments?c=123" -> "treatments"
    const hash = window.location.hash.substring(1).split('?')[0];
    
    // Wait a bit longer on initial load to ensure all content is rendered
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 300);
  }
}; 